import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";
import persistedAuth from "./plugins/persistedAuth";
import websocket from "./plugins/websocket";
import { business } from "./modules/business";

Vue.use(Vuex);

export const initialState = () => ({
  token: "",
  apiKey: "",
  customer: {
    user: { name: { first: "", last: "" }, email: "" },
    personacc: "",
    cards: [],
    frequents: [],
    registered: true,
    super: false,
  },
  orders: [],
  ordersFilter: "nirex",
  points: [],
  legs: [],
  zones: null,
  zonesExpress: null,
  zonesMercadoFlex: null,
  newOrder: null,
  newExpress: null,
  newMercadoFlex: null,
  tracking: null,
  id_order: null,
  example: "example",
  reportOrders: null,
  reportServices: null,
  servicesObject: {},
  mercadoFlexIntegration: false,
});

export default new Vuex.Store({
  state: initialState(),
  getters,
  mutations,
  actions,
  plugins: [persistedAuth, websocket],
  modules: {
    business,
  },
});
